export default "__VITE_ASSET__cEN3TRcE__"